lmApp
  .controller('InvoiceController', ['$scope', '$rootScope', '$templateCache', '$compile', '$timeout', '$window', '$interpolate', 'BillingService',
    function ($scope, $rootScope, $templateCache, $compile, $timeout, $window, $interpolate, BillingService) {

      $rootScope.showLinearProgress('#billsLoader');

      $scope.openPage = function (act) {
        var popupWin = $window.open('', 'newwin', "width=" + 800 + ",height=" + screen.height * 0.9);

        $scope.invoice = {};

        BillingService.GetInvoicePreview($scope.currentPeriod.id)
          .then(function (answer) {
            $scope.invoice = answer;
            $scope.invoice.dueDate = moment.utc(answer.due_time * 1000).subtract(1, 'day');
            $scope.invoice.invoiceDate = moment.utc();

            //scope.$digest();

            if (act == 'print') {
              var tpl = $templateCache.get('billing/invoice.print.tpl.html');
              var html = $compile(tpl)($scope);

              popupWin.document.open();
              popupWin.onload = function () {
                popupWin.print();
              };
              popupWin.document.write(tpl);
              angular.element(popupWin.document.body).html(html);
              popupWin.document.close();
            } else {

              // This pdf generation technique is kind of ugly, it is better to find another solution.

              var tpl = $templateCache.get('billing/invoice.pdf.tpl.html');
              var html = $compile(tpl)($scope);

              popupWin.document.open();

              popupWin.onload = function () {
                var pdf = new jsPDF('p','pt','a4');
                pdf.addHTML(popupWin.document.body, function () {
                  pdf.output('save', 'sotal_invoice_'+ moment.utc().format("MMMM_D_YYYY_hh-mm-ss") +'.pdf');
                });
              };

              popupWin.document.write(tpl);
              angular.element(popupWin.document.body).html(html);

              popupWin.document.close();
            }
          });
      };

      BillingService.GetBillingSubscriptions()
        .then(function (answer) {
          $scope.subscriptionPeriods = answer.subscription.periods.map(function (period) {
            return {
              title: period.name,
              id: period.id,
              start: moment.utc(period.start * 1000),
              end: moment.utc(period.end * 1000).subtract(1, 'day')
            }
          });

          $scope.currentPeriod = $scope.subscriptionPeriods[0];

          $scope.products = answer.subscription.plan.products.map(function (product) {
            return {
              name: product.name,
              code: product.code,
              items: [],
              total: 0
            }
          });
        });

      function getProductInfoAndCost() {
        $scope.total = 0;
        angular.forEach($scope.products, function (obj) {
          obj.total = 0;
          obj.items.length = 0;
        });

        BillingService.GetBillingSubscriptionsDetailsForPeriod($scope.currentPeriod.id)
          .then(function (answer) {

            $scope.invoice = answer.invoice;

            var productInfoAndCost = answer.items.reduce(function (result, item) {
              if (item.product_code in result) {
                result[item.product_code].push(item);
                result['total'] += item.amount;
              } else {
                result[item.product_code] = {
                  'items': [item],
                  'total': item.amount
                }
              }
              return result
            }, []);

            angular.forEach($scope.products, function (obj) {
              if (obj.code in productInfoAndCost) {
                obj.total = productInfoAndCost[obj.code].total;
                obj.items = productInfoAndCost[obj.code].items;
                $scope.total += obj.total;
              }
            });

            $rootScope.hideLinearProgress('#billsLoader');
          })
          .catch(function (reason) {
            console.log(reason);
          });
      }

      $scope.$watch('currentPeriod', function (newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue) && !_.isEmpty(newValue)) {
          $rootScope.showLinearProgress('#billsLoader');
          getProductInfoAndCost();
        }
      });

    }]);